import React from 'react';
import styles from './Footer.module.css';
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className={styles.container}>
      <p className={styles.copyright}>
        &#169; {new Date().getFullYear()} 新青匯有限公司 SYNERGY YOUTH LIMITED
      </p>
      <div className={styles.group}>
        <a
          href="https://www.facebook.com/synergyyouth/"
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebookSquare className={styles.icon} />
        </a>
        <a
          href="https://www.instagram.com/synergyyouthhk/"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className={styles.icon} />
        </a>
      </div>
    </div>
  );
};

export default Footer;
